import script from "./AbilityList.vue?vue&type=script&setup=true&lang=js"
export * from "./AbilityList.vue?vue&type=script&setup=true&lang=js"

import "./AbilityList.vue?vue&type=style&index=0&id=a477770c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a477770c"]])

export default __exports__